import React, { useState, useEffect } from "react";
import {
  Chip,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableContainer,
  TablePagination,
  Typography,
  useTheme,
} from "@material-ui/core";
import { connect } from "react-redux";
import { actions } from "../../../../redux/actions/alert";
import styles from "../../../../styles/global-styles";
import { AuthService } from "../../../../services/auth.service";
import { ProductService } from "../../../../services/product.service";
import { changeRowsPerPage, filterChipsByLote } from "../../../../_utils/utils";
import {
  addAvailabilityToProductsInSite,
  chipsAvailableInSite,
} from "../utils.inventory";
import TableHeadChipProduct from "../../../stateless/headTables/TableHeadChipProduct";
import StyleTableRow from "../../../../styles/styleTableRow";
import StyledTableCell from "../../../../styles/tableCell";
import NumberFormat from "react-number-format";
import IccidChipModal from "../../modals/IccidChipModal";
import ChipHeader from "./headers/ChipHeader";

const useStyles = makeStyles(() => ({
  table: {
    minWidth: 700,
  },
  row: styles.rowHover,
  subtitle: styles.subtitle,
  lowExistence: styles.lowExistence,
  mediumExistence: styles.mediumExistence,
  highExistence: styles.highExistence,
}));

const ChipInventoryBySite = ({ addAlert, detailAlert, history: { push } }) => {
  const classes = useStyles();
  const theme = useTheme();

  const [chipsrray, setChipsArray] = useState([]);
  const [availablesInSite, setAvailablesInSite] = useState({});
  const [countProductsInSite, setCountProductsInSite] = useState(false);
  const [queryParams, setqueryParams] = useState({});
  const [chipByIccid, setchipByIccid] = useState({});
  /** Pagination */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  useEffect(() => {
    (async () => {
      try {
        const { siteId } = AuthService.currentUserValue;
        setqueryParams({ ...queryParams, siteId });
        const { data } = await ProductService.getProductByChipsWithParams({
          siteId,
          inDistribution: 0,
        });
        console.log("data chips", data);
        getChipsAvailable(data);
        setChipsArray(filterChipsByLote(data));
      } catch (error) {
        console.log(error);
        addAlert({ showAlert: true });
        detailAlert({
          severity: "error",
          message: error.msgs || "Error recuperar productos",
        });
      }
    })();
  }, []);

  useEffect(() => {
    if (countProductsInSite) {
      const productsWithAvailability = addAvailabilityToProductsInSite(
        chipsrray,
        availablesInSite
      );

      setChipsArray(productsWithAvailability);
    }
  }, [countProductsInSite]);

  const getChipsAvailable = async (chipsArray) => {
    try {
      const { availableInSite } = await chipsAvailableInSite(chipsArray);
      setAvailablesInSite(availableInSite);
      setCountProductsInSite(true);
    } catch (error) {
      console.log("error", error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: error.msg
          ? error.msg
          : "Error al obtener la disponibilidad de productos",
      });
    }
  };

  const handleChipByIccid = (result, isSuccess) => {
    if (isSuccess) {
      setchipByIccid(result);
    } else {
      addAlert({ showAlert: true });
      detailAlert({
        severity: result.mssgError ? "warning" : "error",
        message: result.mssgError ? result.mssgError : result.msgs,
      });
    }
  };

  const goToUrl = (url, product) => {
    const {
      chip: { lote, siteId },
      productTypeId,
    } = product;
    return push(url, { lote, siteId, productTypeId });
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  return (
    <>
      <ChipHeader
        chipArray={chipsrray}
        chipsInSite
        searchByIccid={handleChipByIccid}
        chipByIccid={chipByIccid}
      />

      <Grid style={{ marginTop: theme.spacing(3) }}>
        <TableContainer>
          {chipsrray.length > 0 ? (
            <Table className={classes.table} aria-label="customized table">
              <TableHeadChipProduct singleSite />
              <TableBody>
                {chipsrray
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, i) => (
                    <StyleTableRow
                      key={i}
                      className={classes.row}
                      onClick={() =>
                        goToUrl(
                          "/dashboard/inventario/sucursal/detalle-producto",
                          row
                        )
                      }
                    >
                      <StyledTableCell align="center">
                        {row.chip?.chip_catalogue.name || ""}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <NumberFormat
                          value={row.chip?.price || 0}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Chip
                          label={row.availablesInSite}
                          className={
                            row.availablesInSite <= 3
                              ? classes.lowExistence
                              : row.availablesInStore <= 7
                              ? classes.mediumExistence
                              : classes.highExistence
                          }
                        />
                      </StyledTableCell>
                    </StyleTableRow>
                  ))}
              </TableBody>
            </Table>
          ) : (
            <Typography
              variant="h6"
              component="h4"
              style={{ marginTop: 50 }}
              className={classes.subtitle}
            >
              No hay chips asignados a esta sucursal
            </Typography>
          )}
        </TableContainer>
        {chipsrray.length > 0 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={chipsrray.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={(event) => {
              const { rowsPerPage, page } = changeRowsPerPage(event);
              setRowsPerPage(rowsPerPage);
              setPage(page);
            }}
          />
        )}
      </Grid>

      {Object.values(chipByIccid).length > 0 && (
        <IccidChipModal
          open={Object.values(chipByIccid).length > 0}
          detailProduct={chipByIccid.chip}
          product={chipByIccid}
          onClose={() => setchipByIccid({})}
          searchBySite
        />
      )}
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(ChipInventoryBySite);
